import React, { useEffect, useRef, useState } from 'react';
import { Icon } from './Primitives';
import './UnityProductNav.css';
const links = [
  ['create', 'Create'],
  ['deliver', 'Deliver'],
  ['adapt', 'Adapt'],
  ['report', 'Report'],
  ['pricing', 'Pricing'],
];
export default function UnityProductNav({ onTrial }) {
  const navRef = useRef(null);
  const [visible, setVisible] = useState(false);
  const [active, setActive] = useState('create');
  useEffect(() => {
    const hero = document.getElementById('unity-top');
    const sections = links.map(([id]) => document.getElementById(id)).filter(Boolean);
    let frame = null;
    const update = () => {
      frame = null;
      const nav = navRef.current;
      if (!nav) return;
      const top = parseFloat(window.getComputedStyle(nav).top) || 0;
      // Section anchors reserve the local navigation height plus a 20px gap.
      const revealLine = top + nav.offsetHeight + 21;
      setVisible(Boolean(hero && hero.getBoundingClientRect().bottom <= revealLine));
      // Keep the preceding section active through gaps and on deep-link loads.
      const activationLine = top + nav.offsetHeight + 24;
      let current = links[0][0];
      sections.forEach((section) => {
        if (section.getBoundingClientRect().top <= activationLine) current = section.id;
      });
      setActive(current);
    };
    const scheduleUpdate = () => {
      if (frame === null) frame = window.requestAnimationFrame(update);
    };
    update();
    window.addEventListener('scroll', scheduleUpdate, { passive: true });
    window.addEventListener('resize', scheduleUpdate);
    window.addEventListener('hashchange', scheduleUpdate);
    return () => {
      if (frame !== null) window.cancelAnimationFrame(frame);
      window.removeEventListener('scroll', scheduleUpdate);
      window.removeEventListener('resize', scheduleUpdate);
      window.removeEventListener('hashchange', scheduleUpdate);
    };
  }, []);
  return (
    <nav
      ref={navRef}
      className={`ul-product-nav ${visible ? 'is-visible' : ''}`}
      aria-label="Unity Learning sections"
      aria-hidden={!visible}
      inert={visible ? undefined : ''}
    >
      <div className="ul-container ul-product-nav-inner">
        <a href="#unity-top" className="ul-product-brand">
          <span className="ul-unity-mark" aria-hidden="true">
            U
          </span>
          Unity Learning
        </a>
        <div className="ul-nav-links">
          {links.map(([id, label]) => (
            <a key={id} href={`#${id}`} aria-current={active === id ? 'location' : undefined}>
              {label}
            </a>
          ))}
        </div>
        <button type="button" className="ul-nav-trial" onClick={onTrial}>
          Request free trial <Icon size={15} />
        </button>
      </div>
    </nav>
  );
}
